/**
 * Navbar
 */
(function( $, window, undefined )
{
	"use strict";

	window.theme = window.theme || {};

	var navbar = {};

	navbar.init = function()
	{
		this.elem = document.getElementById( 'main-navigation' );

		this.originalTheme;
	};

	document.addEventListener( 'DOMContentLoaded', navbar.init.bind( navbar ) );

	navbar.getTheme = function()
	{
		var className = [];

		// get `navbar-light` or `navbar-dark`

		var matches = this.elem.className.match( /\bnavbar-(light|dark)\b/ );

		if ( matches ) 
		{
			className.push( matches[0] );
		}

		// get `bg-{slug}`

		var matches = this.elem.className.match( /\bbg-[\w-]+\b/ );

		if ( matches ) 
		{
			className.push( matches[0] );
		}

		// Return string
		return className.join( ' ' );
	};

	navbar.setTheme = function( className )
	{
		var current = this.getTheme();

		// Save original theme
		if ( this.originalTheme === undefined ) 
		{
			this.originalTheme = current;
		}

		// Switch Theme
		$( this.elem ).removeClass( current ).addClass( className );
	};

	navbar.restoreTheme = function()
	{
		if ( this.originalTheme !== undefined ) 
		{
			this.setTheme( this.originalTheme );
		}
	};

	navbar.getExpand = function()
	{
		var matches = this.elem.className.match( /\bnavbar-expand-([\w-]+)\b/ );

		return matches ? matches[1] : 'xs';
	};

	window.theme.navbar = navbar;

})( jQuery, window );
